import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';

type Props = {
  onClose: () => void;
  networkLimit: number;
};

export function TooManyNetworksModal({ onClose, networkLimit }: Props) {
  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalHeader>Account limit reached</ModalHeader>
      <ModalBody>
        <p className="p">
          You’ve reached the maximum limit of {networkLimit} networks. Please remove unused networks, or contact
          support.
        </p>
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <LinkButton variant="primary" to="/settings/networks">
              Back to networks
            </LinkButton>
          }
          secondaryButton={
            <LinkButton variant="link" to="/support/contact">
              Contact us
            </LinkButton>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
